import { isTeacherEnvironment } from 'appConfig';

const getFileDatafromAPI = (teacherData, studentData) => {
  const fileData = isTeacherEnvironment() ? teacherData : studentData;
  return fileData?.data?.file;
};

export default getFileDatafromAPI;
